import { signOut } from 'owa-locstrings/lib/strings/signout.locstring.json';
import { viewAccount } from 'owa-locstrings/lib/strings/viewaccount.locstring.json';
import { editProfile } from 'owa-locstrings/lib/strings/editprofile.locstring.json';
import { myAccount } from './MeCardPane.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { observer } from 'mobx-react-lite';
import { signout } from '../actions/signout';

const styles = require('./HeaderPane.scss');

const ConsumerLiveEditProfilePageLink = 'https://account.microsoft.com/profile';
const ConsumerLiveAccountSettingsPageLink = 'https://account.microsoft.com';

export default observer(function MeCardPane({ onDismiss }: HeaderPaneProps) {
    const {
        SessionSettings: { UserDisplayName, UserEmailAddress, IsShadowMailbox },
        HexCID,
    } = getUserConfiguration();

    // Fires onDismiss on unmount
    React.useEffect(() => onDismiss, []);

    const onEditProfileClicked = React.useCallback(
        () => window.open(ConsumerLiveEditProfilePageLink, '_blank'),
        []
    );
    const onViewAccountClicked = React.useCallback(
        () => window.open(ConsumerLiveAccountSettingsPageLink, '_blank'),
        []
    );
    const onSignoutClicked = React.useCallback(() => signout(location), []);

    return (
        <HeaderFlexPane
            title={loc(myAccount)}
            onDismiss={onDismiss}
            content={
                <div>
                    <PersonaControl
                        name={UserDisplayName}
                        emailAddress={UserEmailAddress}
                        size={PersonaSize.small}
                        showPersonaDetails={true}
                        hexConsumerIdForUser={HexCID}
                        className={styles.persona}
                    />
                    <ul className={styles.actions}>
                        {!IsShadowMailbox && [
                            <li key="edit">
                                <CommandButton
                                    onClick={onEditProfileClicked}
                                    text={loc(editProfile)}
                                    className={styles.action}
                                />
                            </li>,
                            <li key="view">
                                <CommandButton
                                    onClick={onViewAccountClicked}
                                    text={loc(viewAccount)}
                                    className={styles.action}
                                />
                            </li>,
                        ]}
                        <li>
                            <CommandButton
                                onClick={onSignoutClicked}
                                text={loc(signOut)}
                                className={styles.action}
                            />
                        </li>
                    </ul>
                </div>
            }
        />
    );
});
